export default __webpack_public_path__ + "static/media/health-kit-blue.1ace2be3.svg";